import FormCard from "../../../../../Lib/FormCard";
import FormInput from "../../../../../Lib/FormInput";

const ContactFormDetails = ({ formData, handleChange, isViewOnly = false }) => {
  const data = formData || {};
  console.log('d',data.country)

  // Function to render view-only field
  const renderViewField = (label, value, icon) => (
    <div className="col-md-6 mb-3">
      <div className="view-only-field">
        <label className="form-label">
          <i className={`bi ${icon} me-2`}></i>
          {label}
        </label>
        <div className="view-only-value">{value || "N/A"}</div>
      </div>
    </div>
  );
  return (
    <FormCard title="Contact Details">
      <div className="row g-2">
        {isViewOnly ? (
          <>
            {renderViewField("Country", data.country, "bi-globe")}
            {renderViewField("State", data.state, "bi-geo-alt")}
            {renderViewField("City", data.city, "bi-buildings")}
            {renderViewField("Zipcode", data.zip_code, "bi-file-zip")}
            {renderViewField("Country Code", data.country_code, "bi-geo-alt")}
            <div className="col-12 mb-3">
              <div className="view-only-field">
                <label className="form-label">
                  <i className="bi bi-house me-2"></i>
                  Address
                </label>
                <div className="view-only-value">{data.address || "N/A"}</div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="col-md-6">
              <FormInput
                label="Country"
                icon="bi-globe"
                placeholder="Country"
                name="country"
                value={data.country || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <FormInput
                label="State"
                icon="bi-geo-alt"
                placeholder="State"
                name="state"
                value={data.state || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <FormInput
                label="City"
                icon="bi-buildings"
                placeholder="City"
                name="city"
                value={data.city || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <FormInput
                label="Zipcode"
                icon="bi-file-zip"
                placeholder="Zipcode"
                name="zip_code"
                value={data.zip_code || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6">
              <FormInput
                label="Country Code"
                icon="bi-geo-alt"
                placeholder="Country Code"
                name="country_code"
                value={data.country_code || ""}
                onChange={handleChange}
              />
            </div>

            <div className="col-12">
              <FormInput
                label="Address"
                icon="bi-house"
                placeholder="Full address"
                name="address"
                value={data.address || ""}
                onChange={handleChange}
              />
            </div>
          </>
        )}
      </div>
    </FormCard>
  );
};

export default ContactFormDetails;
